"use client";

// import { TopNav } from "../Header";
// import SideNav from "../SideNav";
import {
  useMediaQuery,
} from "@mui/material";
import theme from "../theme/theme";
import { styled, useTheme } from "@mui/material/styles";
import { HTMLAttributes } from "react";
import { Theme } from "@mui/system";
import Header from "../ui/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { SET_MENU, drawerWidth } from "../store/actions";
import Sidebar from "../ui/Sidebar/Sidebar";
const maincontent = {
  backgroundColor: "#ffff        ",
  width: "100%",
  minHeight: "calc(100vh - 88px)",
  flexGrow: 1,
  padding: "20px",
  marginTop: "88px",
  marginRight: "20px",
  borderRadius: `12px`,
};
const SIDE_NAV_WIDTH = 250;
interface MainProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean;
  theme: Theme;
}
const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "theme",
})<MainProps>(({ theme, open }) => ({
  ...maincontent,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  transition: theme.transitions.create(
    "margin",
    open
      ? {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }
      : {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }
  ),
  [theme.breakpoints.up("md")]: {
    marginLeft: open ? 0 : -(drawerWidth - 20),
    width: `calc(100% - ${drawerWidth}px)`,
  },
  [theme.breakpoints.down("md")]: {
    marginLeft: "20px",
    width: `calc(100% - ${drawerWidth}px)`,
    padding: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    marginLeft: "10px",
    width: `calc(100% - ${drawerWidth}px)`,
    padding: "16px",
    marginRight: "10px",
  },
}));
function DashboardLayout({ children }: any) {
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const leftDrawerOpened = useSelector(
    (state: any) => state.customization.opened
  );
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const handleLeftDrawerToggle = () => {
    dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
  };
  return (
    <div className="dark:bg-boxdark-2 dark:text-bodydark">
    <div className="flex h-screen overflow-hidden">
      {/* <!-- ===== Sidebar Start ===== --> */}
      <Sidebar drawerOpen={leftDrawerOpened}  drawerToggle={handleLeftDrawerToggle} />
      {/* <!-- ===== Sidebar End ===== --> */}

      {/* <!-- ===== Content Area Start ===== --> */}
      <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
        {/* <!-- ===== Header Start ===== --> */}
        <Header sidebarOpen={leftDrawerOpened} handleLeftDrawerToggle={handleLeftDrawerToggle} />
        {/* <!-- ===== Header End ===== --> */}

        {/* <!-- ===== Main Content Start ===== --> */}
        <main>
          <div className="mx-auto p-4 md:p-6 2xl:p-10">
            {children}
          </div>
        </main>
        </div>
    </div>
    </div>
  );
}

export default DashboardLayout;
